import React, { ReactNode, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Button,
  Container,
} from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MenuDrawer from "components/MenuDrawer";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearCurrentOperation } from "redux/features/operationSlice";
import { resetStep } from "redux/features/stepperSlice";
import { useLogoutUserMutation } from "redux/api/authApi";
import WelcomeHeader from "components/Home/WelcomeHeader";
import logoHeader from "assets/logoHeader.svg";
import { useAppSelector } from "redux/store";
import { StatusBar } from "components/Shared/StatusBar";
import { isIOS } from "react-device-detect";


export interface LayoutProps {
  children: ReactNode
}

const Layout = ({ children }: LayoutProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isStandalone = useAppSelector(
    (state) => state.configState.isStandalone
  );
  const [logoutUser, { isLoading, isSuccess, error, isError }] =
    useLogoutUserMutation();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);


  const handleClickStart = () => {
    navigate("/"); // Esto llevará a la ruta "/history"
  };

  const handleClickHistory = () => {
    navigate("/history"); // Esto llevará a la ruta "/history"
  };

  const handleClickPendant = () => {
    navigate("/pendant"); // Esto llevará a la ruta "/history"
  };
  const handleReset = () => {
    dispatch(clearCurrentOperation()); // Reinicia operación
    dispatch(resetStep()); // Reinicia el stepper
    navigate("/");
  };

  // const changePassword = () => {
  //   navigate("/reset-password"); // Esto llevará a la ruta "/history"
  // };

  const onLogoutHandler = async () => {
    logoutUser();
    navigate("/login");
  };

  const isMenuOpen = Boolean(anchorEl);

  return (
    <Box sx={{ minHeight: "100%", bgcolor: "#d9d9d9" }}>
      {/* AppBar */}
      <AppBar position="fixed" color="secondary" sx={{ display: { xs: "none", lg: "block" } }}>
        <Toolbar>
          <Box sx={{
            left: "0%",
          }}>
            <img
              width={110}
              alt="Logo"
              src={logoHeader}
              style={{ objectFit: "contain" }}
            />
          </Box>

          {/* Desktop Horizontal Menu */}
          <Box sx={{ display: { xs: "none", md: "flex" }, gap: 2, flexGrow: 1 }}>
            <Button onClick={handleClickStart} color="inherit">
              Inicio
            </Button>
            <Button onClick={handleClickHistory} color="inherit">
              Histórico
            </Button>
            <Button onClick={handleClickPendant} color="inherit">
              Operaciones pendientes
            </Button>
            <Button onClick={handleReset} color="inherit">
              Nueva Operación
            </Button>
          </Box>

          {/* User Menu */}
          <Box sx={{
            display: { xs: "none", md: "flex", right: "0%" }
          }}>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleMenuOpen}
            >
              <AccountCircle />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={isMenuOpen}
              onClose={handleMenuClose}
              keepMounted
            >
              <MenuItem onClick={onLogoutHandler}>Cerrar sesión</MenuItem>
            </Menu>
          </Box>

          <Box sx={{
            position: "absolute", // Centrado absoluto
            right: "0%",
            paddingRight: "1rem",
            display: { md: "none" }
          }}>
            <MenuDrawer />
          </Box>
        </Toolbar>
      </AppBar>
      <Box sx={{ display: { xs: "block", lg: "none" } }}>
      {isStandalone && isIOS && <StatusBar />}
        <WelcomeHeader />
      </Box>

      {/* Main Content */}
      <Container
        component="main"
        sx={{
          paddingTop: isStandalone
            ? "calc(70px + env(safe-area-inset-top))"
            : "90px",
          flexGrow: 1,
          //paddingTop: { xs: "0px", lg: "80px" },
          minHeight: "100%",
        }}
      >
        {children}
      </Container>
    </Box>
  );
};

export default Layout;
